import { h, FunctionalComponent } from 'preact'
import cn from 'classnames'
import { iMessage } from '../../types/chat'
import { getTime } from '../../utils/date'
import { getContentByType } from '../../utils/chat'
import s from './Message.css'

interface iProps {
  chatId: number,
  message: iMessage,
}

const Message: FunctionalComponent<iProps> = ({ message }) => {
  const { content, date, is_outgoing } = message

  return (
    <div
      className={cn(s.Message, {
        [s.Message_outgoing]: is_outgoing
      })}
    >
      <div
        className={cn(s.Message__content, {
          [s.Message__content_outgoing]: is_outgoing
        })}
      >
        {getContentByType(content)}

        <div
          className={cn(s.Message__date, {
            [s.Message__date_outgoing]: is_outgoing
          })}
        >
          {getTime(date)}
        </div>
      </div>
    </div>
  )
}

export default Message
